import {handBack,insertRoll,itemField,record,scalar,upper,type JanusCtx,type Row} from '../context.js';
import contract from '../../compile/c1-contract.json';
export interface ReadingFacts {
  /** Complete, reader + instance + campaign-bound history, not the visible log page. */
  alreadyRead: boolean;
  languageAllowed: boolean;
  languageName: string;
}
export function finishReading(ctx: JanusCtx, book: Row, caster: Row, facts: ReadingFacts | undefined, remove: () => void): void {
  const pc=record(caster.player_characters);
  if (!pc || !itemField(pc,'item_id')) { remove(); return; }
  const iid=upper(ctx.read.inventoryField?.(book,'inventory_id'));
  const base=upper(itemField(book,'item_id'));
  if (!iid || !base) handBack('timed-finish:reading:book-identity-not-held');
  if (!facts) handBack('timed-finish:reading:history-language-not-held');
  if (facts.alreadyRead) { remove(); return; }
  const skill=upper(ctx.read.value(book,'skill_trained'));
  const meta=contract.rollup.skillEntries.find(s=>upper(s.item_id)===skill);
  // PHP warnings here return from the handler; ft_complete_timed_activity still reports completed.
  if (!meta) { remove(); return; }
  const raw=scalar(ctx.read.value(book,'training_book_tier'));
  const tier=Math.trunc(Number(raw));
  if (raw!=='' && raw!=null && Number.isFinite(Number(raw)) && tier>0) {
    const skills=record(record(record(caster.computed)?.creature)?.skills) ?? record(caster.skills);
    if (!skills) handBack('timed-finish:reading:skills-not-held');
    const current=Number(scalar(record(skills[meta.variable_name])?.tier_level)??0);
    if (current<(tier===1?0:2*tier-1) || current>2*tier) { remove(); return; }
  }
  if (!facts.languageAllowed) { remove(); return; }
  const column=`sp_t_${meta.variable_name}`,before=Math.trunc(Number(scalar(pc[column])??0));
  (ctx.playerCharactersChanged??=[]).push({item_id:upper(itemField(pc,'item_id')),skill_id:skill,column,before,after:before+1});
  pc[column]=before+1;remove();
  insertRoll(ctx,{roll_type_1:'finish_reading',roll_type_2:'',roll_item_id:base,by:caster,to:caster,rolls_full:`ft_finish_read_inv:${iid}`});
}
